import { render, staticRenderFns } from "./InterviewPreviewDetail.vue?vue&type=template&id=c895f1ba&scoped=true"
import script from "./InterviewPreviewDetail.vue?vue&type=script&lang=js"
export * from "./InterviewPreviewDetail.vue?vue&type=script&lang=js"
import style0 from "./InterviewPreviewDetail.vue?vue&type=style&index=0&id=c895f1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c895f1ba",
  null
  
)

export default component.exports